<template>
    <el-menu class="navbar" mode="horizontal">
        <hamburger :isActive="sidebar.opened" :toggleClick="toggleSideBar"
            class="hamburger-container"></hamburger>
        <span class="navbar-title">欢迎 来到正畸智库管理后台</span>
        <el-dropdown class="avatar-container" trigger="click">
            <div class="avatar-wrapper">
                <img :src="avatar" class="user-avatar">
                <span>{{user.displayName}}</span>
                <i class="el-icon-caret-bottom"></i>
            </div>
            <el-dropdown-menu slot="dropdown" class="user-dropdown">
                <router-link class="inlineBlock" to="/">
                    <el-dropdown-item>
                        首页
                    </el-dropdown-item>
                </router-link>
                <el-dropdown-item divided>
                    <span style="display:block;" @click="logout">退出</span>
                </el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>
    </el-menu>
</template>

<script>
import { mapGetters } from "vuex";
import Breadcrumb from "@/components/Breadcrumb";
import Hamburger from "@/components/Hamburger";

export default {
    components: {
        Breadcrumb,
        Hamburger,
    },
    data() {
        return {
            user: {
                displayName: "",
            },
        };
    },
    computed: {
        ...mapGetters(["sidebar", "avatar"]),
    },
    created() {
        this.user = { displayName: this.$store.state.user.name };
    },
    methods: {
        toggleSideBar() {
            this.$store.dispatch("ToggleSideBar");
        },
        logout() {
            this.$store.dispatch("LogOut").then(() => {
                location.reload(); // 为了重新实例化vue-router对象 避免bug
            });
        },
    },
};
</script>

<style lang="scss" rel="stylesheet/scss" scoped>
.navbar-title {
    margin-left: 20px;
}
.navbar {
    height: 60px;
    line-height: 50px;
    border-radius: 0px !important;
    .hamburger-container {
        line-height: 58px;
        height: 50px;
        float: left;
        padding: 0 10px;
    }
    .screenfull {
        position: absolute;
        right: 90px;
        top: 16px;
        color: red;
    }
    .avatar-container {
        height: 50px;
        display: inline-block;
        position: absolute;
        right: 35px;
        .avatar-wrapper {
            cursor: pointer;
            margin-top: 5px;
            position: relative;
            .user-avatar {
                width: 40px;
                height: 40px;
                border-radius: 10px;
            }
            .el-icon-caret-bottom {
                position: absolute;
                right: -20px;
                top: 25px;
                font-size: 12px;
            }
        }
    }
}
</style>




// WEBPACK FOOTER //
// src/views/layout/components/NavbarTitle.vue